import React, { FC } from "react";
import AmericanExpressSVG from "./american-express.svg";

type Props = JSX.IntrinsicAttributes;

export const AmericanExpressIcon: FC<Props> = (props) => {
  return <AmericanExpressSVG {...props} />;
};
